import React from 'react';

import {ElementKeyboardEvent} from 'util/Types';

import LocationSearchDropdown, {LocationSearchDropdownProps} from './LocationSearchDropdown';

// This component is rendered in the menu of ControlledSearchInput, which creates a ref to it.
// A wrapper is needed because LocationSearchDropdown uses a DataConnector, which means the ref will be
// assigned to the HOC. ControlledSearchInput uses the ref to call queryKeyDownHandler for the dropdown menu,
// so we need another class that implements the function and renders LocationSearchDropdown.
export default class LocationSearchDropdownContainer extends React.Component<LocationSearchDropdownProps> {
  // queryKeydownHandler is only invoked indirectly by the ref in ControlledSearchInput.
  queryKeydownHandler(e: ElementKeyboardEvent): boolean {
    return false;
  }

  override render(): JSX.Element {
    return <LocationSearchDropdown {...this.props} />;
  }
}
